import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

import icon1 from '../../theme/assets/svg/lp_academy_s3_icon1.svg';


const AcademyS5 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={Styles.posWrap}>
                    <div className={`${Styles.contentWrapTitle}`}><span>{t('Почему важно пройти')}</span> {t('Академию OMT')}</div>
                    <div className={`${Styles.contentWrapNote}`}>
                        {t('Мы искренне заинтересованы в вашем результате. Нам важно, чтобы каждый участник действовал осознанно, стратегически и с пониманием процессов, а не на эмоциях и случайных решениях. Именно поэтому Академия — это не формальность, а фундамент вашей безопасности, эффективности и будущей прибыльности.')}
                    </div>
                    <div className={`${Styles.contentBox}`}>
                        <div className={`${Styles.contentBoxTitle}`}>{t('Пройдя обучение, вы:')}</div>
                        <div className={`${Styles.contentBoxList}`}>
                            <div className={`${Styles.contentBoxListItem}`}>
                                <div className={`${Styles.contentBoxListItemImgWrap}`}>
                                    <img src={icon1} alt="star"/>
                                </div>
                                <div className={`${Styles.contentBoxListItemText}`}>{t('систематизируете знания')}</div>
                            </div>
                            <div className={`${Styles.contentBoxListItem}`}>
                                <div className={`${Styles.contentBoxListItemImgWrap}`}>
                                    <img src={icon1} alt="star"/>
                                </div>
                                <div className={`${Styles.contentBoxListItemText}`}>{t('научитесь анализировать проекты')}</div>
                            </div>
                            <div className={`${Styles.contentBoxListItem}`}>
                                <div className={`${Styles.contentBoxListItemImgWrap}`}>
                                    <img src={icon1} alt="star"/>
                                </div>
                                <div className={`${Styles.contentBoxListItemText}`}>{t('научитесь управлять рисками и использовать передовые технологии экосистемы OMT с максимальной пользой.')}</div>
                            </div>
                        </div>
                    </div>
                    <div className={`${Styles.contentWrapNote}`}>{t('Это ваше конкурентное преимущество, ваша защита капитала и ваш шаг к более высокому уровню возможностей. Сделайте осознанный выбор уже сегодня.')}</div>
                    <div
                        className={`${Styles.aboutBtn}`}
                        role="button"
                        tabIndex={0}
                        onClick={() => window.open("https://honee.technology/academy", "_blank", "noopener,noreferrer")}
                    >
                        {t('Записаться в Академию')}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AcademyS5;




